var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99967 0.333328C3.31967 0.333328 0.333008 3.31999 0.333008 7C0.333008 10.68 3.31967 13.6667 6.99967 13.6667C10.6797 13.6667 13.6663 10.68 13.6663 7C13.6663 3.31999 10.6797 0.333328 6.99967 0.333328ZM7.66634 10.3333H6.33301V6.33333H7.66634V10.3333ZM7.66634 5H6.33301V3.66666H7.66634V5Z",
    fill: "#C5C5C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.dc80d237d7f5fbdf559d376cbbea39d2.svg";
export { ForwardRef as ReactComponent };